import React from 'react'
import { Typography } from '@mui/material'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Button from '@mui/material/Button'
// import './scss/ForgotPassOTP.css'
import { Link, useNavigate } from 'react-router-dom'
import { useState, useRef, useEffect, useContext } from 'react'
import axios from 'axios'
import { Image } from 'cloudinary-react'
import { MuiOtpInput } from 'mui-one-time-password-input'

const ForgotPassOTP = () => {

    const [verifyOtp, setVerifyOtp] = useState('')
    const [isOtpSubmit, setIsOtpSubmit] = useState(false)

    const handleChange = (newValue) => {
        setVerifyOtp(newValue)
    }
    // const handleChange = (e) => {
    //     setVerifyOtp(e.target.value)
    // }

    const navigate = useNavigate()

    const submitOTP = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_STEELADMIN}/api/auth/verifyOtp`, { verifyOtp })
            if(response.status === 200){
                navigate('/newpassword', { state: { verifyOtp } })
            }
            else if(response.status === 400){
                alert('OTP verification failed.')
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        console.log(verifyOtp)
        setIsOtpSubmit(true)
        submitOTP()
    }
    // , { state: { verifyOtp } }

    // useEffect(() => {
    //     const submitOTP = async () => {
    //         try {
    //             const response = await axios.post(`${process.env.REACT_APP_FPOTP}/api/auth/verifyOtp`, {verifyOtp})
    //             navigate('/newpassword')
    //         } catch (error) {
    //             console.log(error)
    //         }
    //     }
    //     if(isOtpSubmit){
    //         submitOTP()
    //     }
    // }, [isOtpSubmit])

    return (
        <div className="forgotpassOTP">
            <form className="forgotpassOTP-form" action="" onSubmit={handleSubmit}>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: '700',
                        textAlign: 'center',
                        color: '#747474'
                    }}
                >
                    Check your email
                </Typography>
                <Typography
                    variant="p"
                    sx={{
                        fontSize: '14px',
                        fontWeight: '300',
                        textAlign: 'center',
                        marginTop: '5%'
                    }}
                >
                    You'll receive an OTP on your mail.
                </Typography>
                <Typography
                    variant="p"
                    sx={{
                        fontSize: '14px',
                        fontWeight: '400',
                        textAlign: 'center',
                        marginTop: '20%',
                        color: '#767676'
                    }}
                >
                    Enter OTP
                </Typography>
                <MuiOtpInput sx={{marginTop: '10%', color: 'black'}} value={verifyOtp} onChange={handleChange}/>
                {/* <TextField
                    id="outlined-basic"
                    variant="outlined"
                    value={verifyOtp}
                    onChange={(e) => handleChange(e)}
                    sx={{
                        backgroundColor: '#F5F5F5C',
                        borderRadius: '10px',
                        marginTop: '10%',
                    }}
                /> */}
                <Button
                    type="submit"
                    variant="contained"
                    sx={{
                        p: 2,
                        borderRadius: '10px',
                        fontWeight: '400',
                        textTransform: 'capitalize',
                        marginTop: '10%'
                    }}
                >
                    Verify
                </Button>
                <Link to='/forgotpassword' style={{ textDecoration: 'none', color: '#424242', fontSize: '15px', marginTop: '5%' }}>
                    {'<'} Go back
                </Link>
            </form>
        </div>
    )
}

export default ForgotPassOTP